import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import FiveCapabilities from './components/FiveCapabilities';
import EmpowermentSystem from './components/EmpowermentSystem';
import CorporateCulture from './components/CorporateCulture';

export default function AboutPage() {
  return (
    <main>
      <AboutHero />
      <BrandStory />
      <CorporateCulture />
      <EmpowermentSystem />
      <FiveCapabilities />
    </main>
  );
}